import React from "react";
import { ControlLabel, Button, Alert, FormControl, Radio } from "react-bootstrap";
import ajax from "./../../lib/ajax.js";
import context from "./../../lib/context.js";
import DatePicker from "react-bootstrap-date-picker";

export default class AddPage extends React.Component {
    constructor(props) {
        super(props);
        var dateToday = new Date().toISOString();
        
        this.state = {
            idValue: '',
            title: '',
            pageNameLabel: '',
            menuGroupLabel: '',
            htmlContentLabel: '',
            saveLabel: '',
            cancelLabel: '',
            addNewLabel: '',
            deleteLabel: '',
            confirmDeleteLabel: '',
            errors: [],
            linkNameValue: '',
            menuGroupValue: '',
            htmlContentValue: '',
            deleteDisabled: true,
            alertStyle: ''
        }

        this.loadViewModel = this.loadViewModel.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onBack = this.onBack.bind(this);
        this.onAddNew = this.onAddNew.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onPageNameChange = this.onPageNameChange.bind(this);
        this.onMenuGroupChange = this.onMenuGroupChange.bind(this);
        this.onHtmlContentChange = this.onHtmlContentChange.bind(this);
    }

    componentDidMount() {
        this.loadViewModel();
    }

    setEditValues(page) {
        self = this;
        
        self.setState({
            pageNameValue: page.pageName,
            menuGroupValue: page.menuGroup,
            htmlContentValue: page.htmlContent
        });
    }

    setAddValues(data) {
        let linkTypeValue = '';

        this.setState({
            pageNameValue: '',
            menuGroupValue: '',
            htmlContentValue: ''
        });
    }

    loadViewModel() {
        let self = this;
        let path = this.props.location.pathname.split('/');
        let id = '';
        let deleteButton = true;
        
        if (!isNaN(parseInt(path[path.length - 1]))) {
            if (path[path.length - 1] != '0') {
                id = path[path.length - 1];
                deleteButton = false;
            }
        }

        self.setState({
            idValue: id,
            deleteDisabled: deleteButton
        });

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        ajax.vm().get(`add-page/${id}`)
            .then(function (res) {
                self.setState({
                    title: res.data.title,
                    pageNameLabel: res.data.pageNameLabel,
                    menuGroupLabel: res.data.menuGroupLabel,
                    htmlContentLabel: res.data.htmlContentLabel,
                    saveLabel: res.data.saveLabel,
                    cancelLabel: res.data.cancelLabel,
                    addNewLabel: res.data.addNewLabel,
                    deleteLabel: res.data.deleteLabel,
                    confirmDeleteLabel: res.data.confirmDeleteLabel
                });

                if (res.data.page.id !== undefined) {
                    if (res.data.page.id > 0) {
                        self.setEditValues(res.data.page);
                    }
                    else {
                        self.setAddValues(res.data);
                    }
                }
                else {
                    self.setAddValues(res.data);
                }

                context.message({ show: false });
            })
            .catch(function (err) {
                let data = err.response.data;
                context.message({
                    show: true,
                    type: "error",
                    message: data.exceptionMessage || data.message,
                    buttons: "close"
                });
            });
    }

    onSave() {
        let self = this;

        context.message({
            show: true, 
            type: "loading", 
            message:"Loading. Please wait..."
        });

        var pageParam = {
            Id: self.state.idValue,
            PageName: self.state.pageNameValue,
            MenuGroup: self.state.menuGroupValue,
            HtmlContent: self.state.htmlContentValue
        };
        
        self.setState({
            errors: []
        });

        if (self.state.idValue == '') {
            ajax.api().put(`add-page`, pageParam)
                .then(function (res) {
                    context.message({ show: false });

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        });
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            idValue: res.data.id,
                            errors: msg,
                            deleteDisabled: false,
                            alertStyle: 'success'
                        });
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
        else {
            ajax.api().post('edit-page', pageParam)
                .then(function (res) {
                    context.message({ show: false });

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        });    
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'success'
                        })
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
    }

    onBack() {
        let self = this;
        window.location = context.root() + '/app/manage-pages';
    }

    onAddNew() {
        let self = this;
        window.location = context.root() + '/app/add-page/0';
    }

    onDelete() {
        self = this;

        self.setState({
            errors: []
        });

        if (confirm(self.state.confirmDeleteLabel) == true) {
            context.message({
                show: true, 
                type: "loading", 
                message:"Loading. Please wait..."
            });

            ajax.api().post(`delete-page/${this.state.idValue}`)
                .then(function (res) {
                    context.message({ show: false });

                    if (res.data.result == false) {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            alertStyle: 'danger'
                        });
                    }
                    else {
                        let msg = [];
                        msg.push(res.data.message);
                        self.setState({
                            errors: msg,
                            idValue: '',
                            deleteDisabled: true,
                            alertStyle: 'success'
                        })
                    }
                })
                .catch(function (err) {
                    let data = err.response.data;
                    context.message({
                        show: true,
                        type: "error",
                        message: data.exceptionMessage || data.message,
                        buttons: "close"
                    });
                }); 
        }
    }

    onPageNameChange(event) {
        let value = event.target.value;

        this.setState({
            pageNameValue: value
        });
    }

    onMenuGroupChange(event) {
        let value = event.target.value;

        this.setState({
            menuGroupValue: value
        });
    }

    onHtmlContentChange(event) {
        let value = event.target.value;

        this.setState({
            htmlContentValue: value
        });
    }

    render() {
        var rowPaddingTopStyle = {
            "padding-top": "10px"
        };

        return (
            <div className="container">
                <div className="container-fluid">
                    <div className="row">
                        <h2 className="text-center ap-title">{this.state.title}</h2>
                    </div>
                    <br /><br />
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.pageNameLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl type="text" 
                                value={this.state.pageNameValue}
                                onChange={this.onPageNameChange}></FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.menuGroupLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl type="text" 
                                value={this.state.menuGroupValue}
                                onChange={this.onMenuGroupChange}></FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 col-lg-3">
                            <ControlLabel>{this.state.htmlContentLabel}</ControlLabel>
                        </div>
                        <div className="col-md-8 col-lg-9">
                            <FormControl componentClass="textarea" rows="10"
                                value={this.state.htmlContentValue}
                                onChange={this.onHtmlContentChange}></FormControl>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-md-3 col-lg-3"></div>
                        <div className="col-md-3 col-lg-9">
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onSave} className="btn-info ap-fullsize" >{this.state.saveLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onBack} className="btn-info ap-fullsize" >{this.state.cancelLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onAddNew} className="btn-info ap-fullsize" >{this.state.addNewLabel}</Button>
                            </div>
                            <div className="col-md-3 col-lg-3">
                                <Button onClick={this.onDelete} className="btn-info ap-fullsize" disabled={this.state.deleteDisabled}>{this.state.deleteLabel}</Button>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={rowPaddingTopStyle}>
                        <div className="col-md-12 col-lg-12">
                            <div className="col-md-12 col-lg-12">
                                <Alert bsStyle={this.state.alertStyle} className={this.state.errors.length > 0 ? "" : "ap-hidden"}>
                                    <ul>
                                        {this.state.errors.map(m =>
                                            <li key={m}>{m}</li>)}
                                    </ul>
                                </Alert>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}